import React, { useState, useContext } from "react";
import DocContext from "./Context/DocContext";
// import childLetterConst, {
import {
    SPONSOR_LETTER,
    ANNUAL_PROGRESS_REPORT
    // CHILD_LETTER
} from "../../Constants/childLetter";
import Button from "../El/Button";

const ChildInboxMenu = () => {
    const { store, selectMenu } = useContext(DocContext);
    const { menuDisabled } = store;
    const [active, setActive] = useState(null);

    // const icons = [
    //     "fas fa-book-reader",
    //     "fas fa-file-alt",
    //     "fas fa-gift",
    //     "fas fa-file-contract",
    //     "fas fa-gifts",
    //     "fab fa-angellist",
    //     "fas fa-chart-bar"
    // ];

    function setClass(i) {
        if (active === i) {
            return "active";
        } else {
            return "";
        }
    }

    function isDisabled() {
        if (menuDisabled) {
            return true;
        }

        return false;
    }

    function handleClick(code, i) {
        // console.log(i);
        selectMenu(code);
        setActive(i);
    }

    // function handleSubMenuClick(code) {
    //     selectMenu(code);
    // }

    // function childLetterSubMenu(i) {
    //     if ((store.code === "CL" || store.code === "SL") && i === 0) {
    //         return (
    //             <ul className="letter-submenu">
    //                 <li>
    //                     <button
    //                         className="btn-link letter-submenu-button"
    //                         onClick={() =>
    //                             handleSubMenuClick(CHILD_LETTER.code)
    //                         }
    //                     >
    //                         <i className="fas fa-inbox" /> Inbox
    //                     </button>
    //                 </li>

    //                 <li>
    //                     <button
    //                         className="btn-link letter-submenu-button"
    //                         onClick={() =>
    //                             handleSubMenuClick(SPONSOR_LETTER.code)
    //                         }
    //                     >
    //                         <i className="fab fa-telegram-plane" /> Outbox
    //                     </button>
    //                 </li>
    //             </ul>
    //         );
    //     }

    //     return "";
    // }

    return (
        <ul className="inline-list flex-column">
            {/* ------------------------------- */}
            {/* INBOX MENU */}
            {/* ------------------------------- */}
            <li className={setClass(1)}>
                <span>
                    <Button
                        label={"Inbox"}
                        classes="text-left d-block exp-btn link-btn"
                        click={() => handleClick("ALL", 1)}
                        disabled={isDisabled()}
                        icon={"fas fa-inbox"}
                    />
                </span>
            </li>

            {/* ------------------------------- */}
            {/* OUTBOX MENU */}
            {/* ------------------------------- */}
            <li className={setClass(2)}>
                <span>
                    <Button
                        label={"Sent"}
                        classes="text-left d-block exp-btn link-btn"
                        click={() => handleClick(SPONSOR_LETTER.code, 2)}
                        disabled={isDisabled()}
                        icon={"fab fa-telegram-plane"}
                    />
                </span>
            </li>

            {/* ------------------------------- */}
            {/* ANNUAL PROGRESS REPORT */}
            {/* ------------------------------- */}
            {/* <li className={setClass(3)}>
                <span>
                    <Button
                        label={"Annual Progress Report"}
                        classes="text-left d-block exp-btn link-btn"
                        click={() =>
                            handleClick(ANNUAL_PROGRESS_REPORT.code, 3)
                        }
                        disabled={isDisabled()}
                        icon={"fab fa-angellist"}
                    />
                </span>
            </li> */}

            {/* {childLetterConst.map((letter, i) => (
                <li key={i} className={setClass(i)}>
                    <span>
                        <Button
                            label={ letter.label }
                            classes="text-left d-block exp-btn link-btn"
                            click={ () => handleClick(letter.code, i) }
                            disabled={ isDisabled() }
                            icon={ icons[i] }
                        />
                    </span>

                    { childLetterSubMenu(i) }
                </li>
            ))} */}
        </ul>
    );
};

export default ChildInboxMenu;
